/* eslint-disable promise/param-names */
import { AUTH_ERROR, AUTH_REQUEST_DONE, AUTH_REQUEST } from '../actions/auth'
import { SET_BKP, SET_SET_SETTINGS_SAVE, SET_EMAIL_NOTIFICATION, SET_CANCEL, SET_GET_SETS } from '../actions/settings'
import axios from 'axios'
import Vue from 'vue'

const state = {
  settings: localStorage.getItem('user-settings') || {"emailModule":true, "emailNotification": true},
  settingsChange: false,
  settingsBkp: ''
}

const getters = {
  getSettings: state => state.settings,
  settingsChange: state => state.settingsChange
}

const actions = {
  [SET_SET_SETTINGS_SAVE]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      var tokexx = localStorage.getItem('user-token');
      axios.defaults.headers.common['Authorization'] = tokexx;

      var userIdd = localStorage.getItem('user-id');
      axios.post('https://api.personalizedenglish.com.br/sets/updateusersettings', {"userId": userIdd, "settings": state.settings})

        .then(resp => {
        dispatch(SET_BKP)
        dispatch(AUTH_REQUEST_DONE)
        dispatch(SET_CANCEL)
        resolve(resp)
      })
      .catch(err => {
        commit(AUTH_ERROR, err)
        reject(err)
      })
    })
  },
    [SET_EMAIL_NOTIFICATION]: ({commit, dispatch},value) => {
    return new Promise((resolve, reject) => {
      if(state.settingsChange===false){
        commit(SET_BKP)
      }
      var valued = {kind:value.kind, data: ''};

      console.log('SET_EMAIL_NOTIFICATION')
      console.log(value)
      if(value.data==="true"){
        console.log('SET_EMAIL_NOTIFICATION value.data==="true"')
        valued.data = true;
        commit(SET_EMAIL_NOTIFICATION, valued)
        resolve()
      }else{
        console.log('SET_EMAIL_NOTIFICATION value.data==="other"')
        valued.data = false;
        commit(SET_EMAIL_NOTIFICATION, valued)
        resolve()
      }
      //commit(SET_EMAIL_NOTIFICATION, value)
    })
  },
  [SET_GET_SETS]: ({commit, dispatch},settings) => {
    return new Promise((resolve, reject) => {
      console.log('SET_GET_SETS SET_GET_SETS',settings)
      commit(SET_GET_SETS,settings)
      resolve()
    })
  },
  [SET_CANCEL]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(SET_CANCEL)
      resolve()
    })
  },
  [SET_BKP]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(SET_BKP)
      resolve()
    })
  }
}

const mutations = {
  [SET_GET_SETS]: (state, settings) => {
    state.settingsChange = false;
    state.settings = settings;
    //Vue.set(state, 'settings', settings)
    localStorage.setItem('user-settings', settings)
  },
  [SET_EMAIL_NOTIFICATION]: (state, value) => {
    console.log('SET_EMAIL_NOTIFICATION MUTATION')
    console.log('value.data',value.data)
    console.log('value.kind',value.kind)
    state.settingsChange = true;
    if(value.kind==='emailNotification'){
      state.settings.emailNotification = value.data
      localStorage.setItem('user-settings', state.settings)
    }else if(value.kind==='emailModule'){
      state.settings.emailModule = value.data
      localStorage.setItem('user-settings', state.settings)
    }
  },
  [SET_CANCEL]: (state) => {
    state.settingsChange = false
    var clone = _.clone(state.settingsBkp, true);
    state.settings = clone
  },
  [SET_BKP]: (state) => {
    var clone = _.clone(state.settings, true);
    console.log('USER_PROFILE_BKP',clone)
    state.settingsBkp = clone
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js